import { Outlet, useLocation } from "react-router-dom";
// Header et footer partagés avec les pages legacy : la navigation doit être
// identique sur tout le site, y compris /search.
import { Navbar } from "../../components/header.jsx";
import { Footer } from "../../components/footer.jsx";
import "../frontoffice.css";

export default function FrontofficeLayout() {
  const { pathname } = useLocation();

  return (
    <div className="fo-app">
      <Navbar current={pathname} />
      <main className="fo-main">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
